import { memo } from 'react'
import { VideoCard, type VideoItem } from './video-card'

interface VideoGridProps {
  videos: VideoItem[]
  onPlay: (video: VideoItem) => void
}

/**
 * Memoized video grid for community gallery.
 * VideoCard handles its own callback memoization since onPlay receives the video directly.
 */
export const VideoGrid = memo(function VideoGrid({ videos, onPlay }: VideoGridProps) {
  if (videos.length === 0) {
    return <EmptyState />
  }

  return (
    <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
      {videos.map((video) => (
        <div key={video.id} className="break-inside-avoid">
          <VideoCard video={video} onPlay={onPlay} />
        </div>
      ))}
    </div>
  )
})

const EmptyState = memo(function EmptyState() {
  return (
    <div className="text-center py-20 text-[#666] glass rounded-xl">
      <p>No videos yet. Be the first to create one!</p>
    </div>
  )
})
